import HeroCarousel from './components/HeroCarousel';
import createHowItWorksCarousel from './components/hiw-carousel';
import createProductFeatures from './components/product-features';
import Accordion from './components/Accordion';
import ScrollToElement from './components/ScrollToElement';
import ServiceDesignerFilter from './components/ServiceDesignerFilter';

document.addEventListener('DOMContentLoaded', () => {
    // Hero carousel
    HeroCarousel.create().start();

    // How it works
    createHowItWorksCarousel(document.querySelector('[data-hiw]'));

    // Product features
    createProductFeatures();

    // FAQs
    Accordion.create();

    // Scroll to service designers link
    const links = document.querySelectorAll('[data-service-designers-link]');

    for (var i = 0; i < links.length; i++) {
        new ScrollToElement(links[i]).handleClick();
    }

    ServiceDesignerFilter.create();
});



// WEBPACK FOOTER //
// ./js/marketing/service.js